// extracted by mini-css-extract-plugin
export var contentBody = "_az-9";
export var headerImage = "_az-2";
export var imageButton = "_az-7";
export var imageButtonIcon = "_az-8";
export var imageHeader = "_az-4";
export var imageHeaderText = "_az-5";
export var imageOverlay = "_az-3";
export var imageTitle = "_az-6";
export var imageWrapper = "_az-1";
export var taskList = "_az-a";
export var widget = "_az-0";